import React from "react";
import { AI_STARTERS } from "./flowConfig";

const STATS = [
  ["🏔️", "45+", "Live Departures"],
  ["📍", "700+", "Sights & Monasteries"],
  ["🚗", "100%", "Verified Cabs"],
  ["🏨", "Curated", "Boutique Stays"],
];

/**
 * Welcome showcase shown in AI mode until the user sends their first message
 * (same content as the full-page /chatbot hero, laid out for the widget).
 */
export default function AiHero({ onPick, disabled, wide }) {
  return (
    <div className="flex flex-col items-center text-center mt-2 mb-4">
      <span className="text-[10px] font-bold uppercase tracking-wider text-emerald-700 bg-emerald-50 border border-emerald-200 rounded-full px-3 py-1">
        Next-Gen Himalayan Travel Specialist
      </span>
      <h2 className="text-lg font-extrabold text-slate-900 mt-3 mb-1">Where does your journey begin?</h2>
      <p className="text-xs text-slate-500 max-w-md mb-3">
        Real-time departures, 700+ sightseeing secrets, verified mountain cabs and handpicked stays across Himachal, Sikkim, Spiti &amp; Kashmir.
      </p>

      <div className="flex flex-wrap justify-center gap-1.5 mb-3">
        {STATS.map(([icon, strong, label]) => (
          <span key={label} className="text-[11px] font-semibold text-slate-700 bg-white border border-slate-200 rounded-full px-2.5 py-1">
            {icon} <strong className="text-emerald-600">{strong}</strong> {label}
          </span>
        ))}
      </div>

      <div className={`grid gap-2 w-full max-w-xl ${wide ? "grid-cols-2" : "grid-cols-1"}`}>
        {AI_STARTERS.map((s) => (
          <button
            key={s.label} type="button" disabled={disabled} onClick={() => onPick(s.query)}
            className="flex items-start gap-3 text-left bg-white border border-slate-200 hover:border-teal-600 hover:-translate-y-0.5 hover:shadow-md rounded-xl p-3 transition disabled:opacity-50"
          >
            <span className="text-xl leading-none mt-0.5">{s.icon}</span>
            <span className="min-w-0">
              <span className="block text-[13px] font-bold text-slate-900">{s.label}</span>
              <span className="block text-[11px] text-slate-500 leading-snug">{s.desc}</span>
            </span>
          </button>
        ))}
      </div>
    </div>
  );
}